// extracted by mini-css-extract-plugin
export default {"default":"TypeIndicator_default__HY19F"};